export const VALIDATION_MESSAGES = {
    NO_BOOKINGS: 'Please select at least one booking to generate a timesheet',
    MISSING_AGENT: 'Agent information is required',
    MISSING_CONSULTANT_CODE: 'Consultant code is required',
    MISSING_TIMESHEET_DATE: 'Timesheet date is required',
    MISSING_PERSONNEL_REF: 'Personnel reference is required',
    MISSING_CLIENT_REF: 'Client reference is required',
    MISSING_DIVISION: 'Division information is required',
    MISSING_DEPARTMENT: 'Department information is required',
    MISSING_DESCRIPTION: 'Description is required',
    MISSING_DURATION: 'Duration is required',
    MISSING_HOURLY_RATE: 'Hourly rate is required',
    MISSING_CLIENT_PAY: 'Client pay is required',
    MISSING_RATE_CODE: 'Rate code is required',
    MISSING_RATE_DESCRIPTION: 'Description is required',
} as const;

export const INPUT_STEPS = {
    DURATION: 0.01,
    CURRENCY: 0.01,
} as const;

